import React from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid';

const SourceFooter = ({ dataset, isZh = false }) => {
    if (!dataset) return null;

    if (dataset.status === 'planned') {
        return (
            <div className="ai-dev-planned">
                <span>{isZh ? '待办' : 'Planned'}</span>
                <p>{dataset.coverageNote}</p>
            </div>
        );
    }

    return (
        <footer className="ai-dev-source">
            <div>
                <span>{isZh ? '数据来源' : 'Source'}</span>
                <a href={dataset.sourceUrl} target="_blank" rel="noreferrer">
                    {dataset.sourceName}<ArrowTopRightOnSquareIcon aria-hidden="true" />
                </a>
                <span className="ai-dev-source__coverage">
                    {dataset.coverageStart} — {dataset.coverageEnd} · {dataset.status === 'partial' ? (isZh ? '局部覆盖' : 'partial') : (isZh ? '来源快照' : 'source snapshot')}
                </span>
            </div>
            <details>
                <summary>{isZh ? '口径与局限' : 'Method & limits'}</summary>
                <p>{dataset.methodologyNote}</p>
                <p>{dataset.coverageNote}</p>
            </details>
        </footer>
    );
};

export default SourceFooter;
